import queueUtagCall from './queueUtagCall';

function utagLinkEmailSignup (email) {

	if (email.length > 0) {

		queueUtagCall(() => {

			const linkFunction = window.top.utag.link;
			const thisArg = window.top.utag;

			linkFunction.call(thisArg, {
				event_name: 'email_signup',
				customer_email: email
			});

		});

	}

}

export default utagLinkEmailSignup;
